import React, { useEffect, useLayoutEffect, useState, useRef } from 'react';
import styled from 'styled-components';
import { Sheet } from 'react-modal-sheet';

// Create a custom styled component for the Sheet
const CustomSheet = styled(Sheet)`
  .react-modal-sheet-container {
    background-color: white;
    border-radius: 1.6em;
    /* Do not set overflow:hidden here — it fights the scroller */
  }
  .react-modal-sheet-content {
    background-color: var(--ui-background-color);
    /* flex item must be allowed to shrink or the scroller grows with content */
    min-height: 0 !important;
  }
  .react-modal-sheet-header {
    border-top-left-radius: 1.6em;
    border-top-right-radius: 1.6em;
    flex-shrink: 0;
  }
  .react-modal-sheet-scroller {
    /* Classic flex gotcha: without min-height:0 the scroller won't shrink
       below its content height, so overflow:auto never activates. */
    flex: 1 1 auto;
    height: auto !important;
    max-height: 100%;
    min-height: 0 !important;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;
  }
`;


const Header = styled.div`
/* border: 1px solid red; */
/* width: 100%; */
left: 0;
/* right: 1em; */
padding: 0 1.4em;
height: 4em;
display: flex;
flex-direction: row;
align-items: center;
background: white;
z-index: 100;
cursor: pointer;
user-select: none;
position: relative;
top: ${(props) => `${props.offsetY}px`};
`;


export function PopInfo(props) {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 991); // Set initial state based on window size

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 991); // Update state based on window size
    };

    window.addEventListener('resize', handleResize); // Add event listener for resize

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup listener on component unmount
    };
  }, []);

  return (
    <>
      {isMobile ? (<>
        {/* TODO: Comment this if fails */}
        <PopModal {...props} />
        {/* <PopWeb {...props} /> */}
      </>
      ) : (
        <PopWeb {...props} />
      )}
    </>
  );
}


export function PopWeb(props) {

  const {
    id,
    children,
    handleClose = () => void (0),
    type = '',
    title = '',
    icon,
    addContent,
    addClassName
  } = { ...props };


  const [isMobile, setIsMobile] = useState(window.innerWidth < 479);
  const [offsetY, setOffsetY] = useState(0); // Initial transformY is 200px
  const [addClassNameInner, setAddClassNameInner] = useState(addClassName); // Initial transformY is 200px

  useEffect(() => {
    setAddClassNameInner(addClassName)
  }, [addClassName]);

  return (<>
    <div className={`x_info0 ${addClassName}`}
      onClick={(e) => !isMobile && e.stopPropagation()}
    >
      <div className="x_info_z inact active" onClick={handleClose} />
      <div className={`x_info ${addClassNameInner}`}
        onClick={(e) => e.stopPropagation()}
      // ref={mainElementRef}
        style={{ transform: `translateY(${offsetY}px)` }}
      >
        <div className="x_info_mobileindicator" />
        <div
          className="x_info_inner active"
          style={{
            // maxHeight: offsetY,
            // overflow: 'hidden',
            transition: 'max-height 0.2s ease',
          }}
        >
          <div
            className={`m_b_h m_b_h--${type}`}
          >
            {/* <div className="m_b_h_icon">
              <div className="t_icon t_icon--20">
                {icon}
              </div>
            </div> */}
            {/* <div className="m_b_h_title">
              {title}
            </div> */}
            {/* <div className="x_edu_title x_edu_title--center">
              {title}
            </div> */}
            <div className={`x_pop_right x_pop_right--${type}`}>
              <div className="x_action x_action--white" onClick={handleClose}>
                <div className="t_icon t_icon--20">
                  close
                </div>
              </div>
            </div>
          </div>
          {children}
        </div>
      </div>
    </div>

  </>
  );
}



// snapPoints={[-50, 0.5, 200]} — index 0 = near-full, 1 = half, 2 = peek
const SNAP_FULL = 0;
const SNAP_HALF = 1;
const SHEET_SNAP_POINTS = [-50, 0.5, 200];

export function PopModal({
  active, // External parameter to control modal visibility
  id,
  children,
  handleClose = () => void (0),
  type = '',
  title = '',
  icon,
  addContent,
  addClassName = ''
}) {
  const [isOpen, setOpen] = useState(active); // Set initial state based on active prop
  const [currentSnap, setCurrentSnap] = useState(SNAP_HALF); // Track the current snap point
  const sheet = useRef(null); // Initialize the ref

  // iOS-style: content scrolls only when the sheet is fully expanded.
  // Below that, Content drag raises/lowers the sheet.
  const isFullyExpanded = currentSnap === SNAP_FULL;

  useLayoutEffect(() => {
    if (!isOpen) return undefined;

    const body = document.body;
    const scrollY = window.scrollY || document.documentElement.scrollTop || 0;

    body.classList.add('noscroll', 'zoomed-out');
    body.style.position = 'fixed';
    body.style.top = `-${scrollY}px`;
    body.style.left = '0';
    body.style.right = '0';
    body.style.width = '100%';

    return () => {
      body.classList.remove('noscroll', 'zoomed-out');
      body.style.removeProperty('position');
      body.style.removeProperty('top');
      body.style.removeProperty('left');
      body.style.removeProperty('right');
      body.style.removeProperty('width');
      window.scrollTo(0, scrollY);
    };
  }, [isOpen]);

  useEffect(() => {
    // Update modal visibility when active prop changes
    setOpen(active);
  }, [active]);

  return (
    <CustomSheet
      style={{
        zIndex: 1000
      }}
      isOpen={isOpen}
      disableScrollLocking
      onClose={() => {
        setOpen(false);
        handleClose();
      }}
      snapPoints={SHEET_SNAP_POINTS}
      initialSnap={SNAP_HALF}
      ref={sheet}
      onSnap={(snap) => setCurrentSnap(snap)}
    >
      <Sheet.Container>
        <Sheet.Header>
          <div className="x_info_mobileindicator" />


          <div className='x_mobile_info_title'
            style={{
              height: '4em'
            }}
          >
            <div className="x_mobile_info_title_text">
            {title || ''}
            </div>

            {/* <div className="x_edu_title x_edu_title--center">
              {title}
            </div> */}
            <div
              className={`m_b_h m_b_h--${type}`}
            >

              <div className={`x_pop_right x_pop_right--${type}`}>
                <div className="x_action x_action--main x_action--white mobile_v_yes"
                >
                  {(currentSnap === 1 || currentSnap === 2) && <div className="t_icon t_icon--20"
                    onClick={() => {
                      sheet.current?.snapTo(SNAP_FULL);
                    }}
                  >
                    keyboard_arrow_up
                  </div>}
                  {currentSnap === SNAP_FULL && <div className="t_icon t_icon--20"
                    onClick={() => {
                      sheet.current?.snapTo(SNAP_HALF);
                    }}
                  >
                    keyboard_arrow_down
                  </div>}
                </div>
                <div className="x_action x_action--white" onClick={() => {
                  handleClose()
                  setOpen(false);
                }}>
                  <div className="t_icon t_icon--20">
                    close
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Sheet.Header>
        <Sheet.Content
          // Below full height: drag the sheet (no inner scroll).
          // At full height: disable Content drag so Sheet.Scroller can scroll;
          // header remains draggable to collapse.
          disableDrag={isFullyExpanded}
          style={{ paddingBottom: sheet.current?.y }}
        >
          <Sheet.Scroller
            draggableAt="top"
            style={{
              // Gate scroll by snap only — no touch preventDefault hacks.
              overflowY: isFullyExpanded ? 'auto' : 'hidden',
              minHeight: 0,
              flex: 1,
            }}
          >
            {children}
          </Sheet.Scroller>
        </Sheet.Content>
      </Sheet.Container>


      <Sheet.Backdrop onClick={() => {
        setOpen(false);
        handleClose();
      }} />
    </CustomSheet >
  );
}
